import { useState, useEffect } from 'react';

const getWidth = () => {
    if (typeof window !== "undefined") {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
};
const useWindowSize = () => {
    const [width, setWidth] = useState(getWidth());
    useEffect(() => {
        let timeoutId;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            // change width from the state object after 150 milliseconds
            timeoutId = setTimeout(() => setWidth(getWidth()), 150);
        };
        window.addEventListener("resize", resizeListener);
        // clean up function
        return () => {
            window.removeEventListener("resize", resizeListener);
        };
    }, []);
    return width;
};

export { useWindowSize };
//# sourceMappingURL=useWindowSize.js.map
